<template>
  <div class="results-component py-[50px] rounded-[12px]" v-if="searchData && searchData.length > 0">
    <div v-for="(searchList, i) in searchData" v-bind:key="i" class="bg-[#FFFFFF] min-w-[500px] max-w-[90%] mx-auto p-[20px]">
      <div v-if="searchList.type === 'account'" class="mb-[10px  ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ getTotalCount(searchList) > 1 ? 'Accounts' : 'Account' }} 
            &#x2022; 
            {{ getTotalCount(searchList) }}
          </h2>
          <AccountsList :accounts="searchList" />
        </div>
      </div>

      <div v-if="searchList.type === 'block'" class="mb-[10px  ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ getTotalCount(searchList) > 1 ? 'Blocks' : 'Block' }} 
            &#x2022; 
            {{ getTotalCount(searchList) }}
          </h2>
          <BlocksList :blocks="searchList" />  
        </div>
      </div>

      <div v-if="searchList.type === 'transaction'" class="mb-[10px ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ getTotalCount(searchList) > 1 ? 'Transactions' : 'Transaction' }} 
            &#x2022; 
            {{ getTotalCount(searchList) }}
          </h2>
          <TransactionsList :transactions="searchList" />
        </div>       
      </div>  
      <div v-if="searchList.type === 'token'" class="mb-[10px  ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ getTotalCount(searchList) > 1 ? 'Tokens' : 'Token' }} 
            &#x2022; 
            {{ getTotalCount(searchList) }}
          </h2>
          <TokensList :tokens="searchList" />
        </div>       
      </div>       
      <div v-if="searchList.type === 'nft'" class="mb-[10px  ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ getTotalCount(searchList) > 1 ? 'NFTs' : 'NFT' }} 
            &#x2022; 
            {{ getTotalCount(searchList) }}
          </h2>
          <NFTsList :nfts="searchList" />
        </div>       
      </div>       
      <div v-if="searchList.type === 'chain'" class="mb-[10px  ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ getTotalCount(searchList) > 1 ? 'Chains' : 'Chain' }} 
            &#x2022; 
            {{ getTotalCount(searchList) }}
          </h2>
          <ChainsList :chains="searchList" />
        </div>       
      </div>
      <div v-if="searchList.type === 'meta'" class="mb-[10px  ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ getTotalCount(searchList) > 1 ? 'Metadatas' : 'Metadata' }} 
            &#x2022; 
            {{ getTotalCount(searchList) }}
          </h2>
          <MetadataList :metadata="searchList" />
        </div>       
      </div>
       <div v-if="searchList.type === 'asset'" class="mb-[10px  ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ getTotalCount(searchList) > 1 ? 'Assets' : 'Asset' }} 
            &#x2022; 
            {{ getTotalCount(searchList) }}
          </h2>
          <AssetsList :assets="searchList" />
        </div>       
      </div>      
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TransactionsList from '@/components/common/TransactionsList.vue';
import BlocksList from '@/components/common/BlocksList.vue';
import AccountsList from '@/components/common/AccountsList.vue';
import TokensList from '@/components/common/TokensList.vue';
import NFTsList from '@/components/common/NFTsList.vue';
import ChainsList from '@/components/common/ChainsList.vue';
import MetadataList from '@/components/common/MetadataList.vue';
import AssetsList from '@/components/common/AssetsList.vue';

export default {
  name: "ResultsComponent",
  components: {
    TransactionsList,
    BlocksList,
    AccountsList,
    TokensList,
    NFTsList,
    ChainsList,
    MetadataList,
    AssetsList,
  },
  props: {
    // Define props here if needed
  },
  data() {
    return {
      //
    };
  },
  computed: {
    ...mapGetters({
      searchData: 'getSearchData',
    }),
  },
  created() {
    if (!this.searchData || this.searchData.length === 0) {
      // Handle case where there is no search data
      this.$store.dispatch('searchBlockchain', this.$route.query.value || '');
    }
  },
  methods: {
    getTotalCount(list) {
      if (!list) return 0;
      if (typeof list.total === 'number') return list.total;
      if (list.meta && typeof list.meta.count === 'number') return list.meta.count;
      return Array.isArray(list.items) ? list.items.length : 0;
    },
    formatDateTime(timestamp) {
      const date = new Date(timestamp);
      const dateOptions = { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      };
      const timeOptions = { 
        hour: 'numeric', 
        minute: '2-digit', 
        second: '2-digit',
        hour12: true 
      };
      
      const formattedDate = date.toLocaleDateString('en-US', dateOptions);
      const formattedTime = date.toLocaleTimeString('en-US', timeOptions);
      
      return `${formattedDate}, ${formattedTime}`;
    },
    truncateAddress(address) {
      if (!address || address === 'N/A') {
        return address;
      }
      
      if (address.length <= 10) {
        return address;
      }
      
      // Show first 4 and last 5 characters without ellipsis
      const start = address.slice(0, 6);
      const end = address.slice(-5);
      return `${start}...${end}`;
    },
  
  },
  mounted() {
    // Lifecycle hook for when the component is mounted
  },
};
</script>

<style scoped>
 .results-component div:first-child {
   border-radius: 12px 12px 0 0;
 }
 .results-component div:last-child {
   border-radius: 0 0 12px 12px;
 }
</style>